import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "inherit",
      stroke: "inherit",
      d: "M21 50a29 29 0 0 0 58 0 29 33 0 0 1-58 0"
    }, [
      _createElementVNode("animateTransform", {
        attributeName: "transform",
        dur: "1s",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        type: "rotate",
        values: "0 50 52;360 50 52"
      })
    ], -1)
  ])))
}
export default { render: render }